// Filter chip for /prompt-gallery. Rendered via `MarketplaceFilters`-style
// pattern: parent passes `children: PROMPT_CATEGORIES` (object-keyed),
// so each chip element receives `el.key` (the category id) and the
// entry's `label` as a flat prop.
//
// Reads/writes `s.activeCategory` directly — `s` resolves to the page
// `state` block declared on `promptGallery`. Single-select (chip toggle
// replaces, doesn't union) — gallery is small enough that AND-style
// multi-select would just confuse the rail.

export const PromptGalleryChip = {
  tag: 'button',
  type: 'button',
  flow: 'x',
  align: 'center center',
  gap: 'X',
  padding: 'Y A',
  borderRadius: 'D',
  border: '1px solid',
  cursor: 'pointer',
  fontSize: 'Y2',
  fontWeight: '600',
  whiteSpace: 'nowrap',
  transition: 'X defaultBezier background-color, X defaultBezier color, X defaultBezier border-color',

  background: (el, s) => (s.activeCategory === el.key ? 'blue' : 'transparent'),
  color: (el, s) => (s.activeCategory === el.key ? 'white' : 'title'),
  borderColor: (el, s) => (s.activeCategory === el.key ? 'blue' : 'line'),
  ':hover': { borderColor: 'blue' },

  text: (el) => el.label || el.key,

  onClick: (e, el, s) => {
    s.update({ activeCategory: el.key })
  }
}
